import { RouteConfig } from "vue-router";
import RouterProxyComponent from "../components/RouterProxyComponent.vue";
import { E_RouterNames } from "./types";

export function makeAlarmCenterRouter(redirect: RouteConfig['redirect']): RouteConfig[] {
    return [
    {
        path: "/alarmCenter",
        name: E_RouterNames.alarmCenter,
        redirect,
        component: RouterProxyComponent,
        children: [
            // 温振报警
            {
                path: 'TempVibAlarm',
                name: E_RouterNames.TempVibAlarm,
                component: () =>
                        import(
        /* webpackChunkName: "temperatureVibAlarm" */ "../views/alarmCenter/equipmentAlarm/temperatureVibAlarm.vue"
                        ),
            },
            // 温振报警(历史)
            {
                path: 'TempVibAlarmHistory',
                name: E_RouterNames.TempVibAlarmHistory,
                meta: {
                    parentName: E_RouterNames.TempVibAlarm,
                },
                component: () =>
                        import(
        /* webpackChunkName: "temperatureVibAlarm" */ "../views/alarmCenter/equipmentAlarm/temperatureVibAlarmHistory.vue"
                        ),
            },

            // 气体报警
            {
                path: 'gasAlarm',
                name: E_RouterNames.gasAlarm,
                component: () =>
                        import(
        /* webpackChunkName: "gasAlarm" */ "../views/alarmCenter/equipmentAlarm/gasAlarm.vue"
                        ),
            },
            // 气体报警(历史)
            {
                path: 'gasAlarmHistory',
                name: E_RouterNames.gasAlarmHistory,
                meta: {
                    parentName: E_RouterNames.gasAlarm,
                },
                component: () =>
                        import(
        /* webpackChunkName: "gasAlarm" */ "../views/alarmCenter/equipmentAlarm/gasAlarmHistory.vue"
                        ),
            },

            // 粉尘报警
            {
                path: 'gdsAlarm',
                name: E_RouterNames.gdsAlarm,
                component: () =>
                        import(
        /* webpackChunkName: "gdsAlarm" */ "../views/alarmCenter/equipmentAlarm/gdsAlarm.vue"
                        ),
            },
            // 粉尘报警(历史)
            {
                path: 'gdsAlarmHistory',
                name: E_RouterNames.gdsAlarmHistory,
                meta: {
                    parentName: E_RouterNames.gdsAlarm,
                },
                component: () =>
                        import(
        /* webpackChunkName: "gdsAlarm" */ "../views/alarmCenter/equipmentAlarm/gdsAlarmHistory.vue"
                        ),
            },


            // 电压报警
            {
                path: 'BatteryAlarm',
                name: E_RouterNames.BatteryAlarm,
                component: () =>
                        import(
        /* webpackChunkName: "BatteryAlarm" */ "../views/alarmCenter/sensorAlarm/batteryAlarm.vue"
                        ),
            },
            // 电压报警(历史)
            {
                path: 'BatteryAlarmHistory',
                name: E_RouterNames.BatteryAlarmHistory,
                meta: {
                    parentName: E_RouterNames.BatteryAlarm,
                },
                component: () =>
                        import(
        /* webpackChunkName: "BatteryAlarm" */ "../views/alarmCenter/sensorAlarm/batteryAlarmHistory.vue"
                        ),
            },



            // 终端移位
            {
                path: 'AngleAlarm',
                name: E_RouterNames.AngleAlarm,
                component: () =>
                        import(
        /* webpackChunkName: "angleAlarm" */ "../views/alarmCenter/sensorAlarm/angleAlarm.vue"
                        ),
            },
            // 终端移位(历史)
            {
                path: 'AngleAlarmHistory',
                name: E_RouterNames.AngleAlarmHistory,
                meta: {
                    parentName: E_RouterNames.AngleAlarm,
                },
                component: () =>
                        import(
        /* webpackChunkName: "angleAlarm" */ "../views/alarmCenter/sensorAlarm/angleAlarmHistory.vue"
                        ),
            },



            // 离线报警
            {
                path: 'OfflineAlarm',
                name: E_RouterNames.OfflineAlarm,
                component: () =>
                        import(
        /* webpackChunkName: "offlineAlaram" */ "../views/alarmCenter/sensorAlarm/offlineAlarm.vue"
                        ),
            },
            // 离线报警(历史)
            {
                path: 'OfflineAlarmHistory',
                name: E_RouterNames.OfflineAlarmHistory,
                meta: {
                    parentName: E_RouterNames.OfflineAlarm,
                },
                component: () =>
                        import(
        /* webpackChunkName: "offlineAlaram" */ "../views/alarmCenter/sensorAlarm/offlineAlarmHistory.vue"
                        ),
            },


            // 邮件推送
            {
                path: 'MailPush',
                name: E_RouterNames.MailPush,
                component: () =>
                        import(
        /* webpackChunkName: "MailPush" */ "../views/alarmCenter/pushAlarm/emailPush.vue"
                        ),
            },
            // 微信推送
            {
                path: 'WechatPush',
                name: E_RouterNames.WechatPush,
                component: () =>
                        import(
        /* webpackChunkName: "WechatPush" */ "../views/alarmCenter/pushAlarm/wechatPush.vue"
                        ),
            },
            // 语音推送
            {
                path: 'VoicePush',
                name: E_RouterNames.VoicePush,
                component: () =>
                        import(
        /* webpackChunkName: "VoicePush" */ "../views/alarmCenter/pushAlarm/voicePush.vue"
                        ),
            },

        ]
    }
]
}
